import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { NavigationService } from 'src/app/modules/_services/navigation.service';
import * as alerts from '../../../_functions/alerts';

@Component({
  selector: 'lovers-card-desafio',
  templateUrl: './card-desafio.component.html',
  styleUrls: ['./card-desafio.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardDesafioComponent implements OnInit {
  @Input() public titulo: string = '';
  @Input() public descricao: string = '';
  @Input() public valorPontosRecompensa: number = 0;
  @Input() public valorCacausRecompensa: number = 0;
  @Input() public porcentagemDesafio: number = 0;
  @Input() public desafioCompleto: boolean = false;
  @Input() public inicioDesafio: Date = new Date();
  @Input() public fimDesafio: Date = new Date();
  @Input() public desafioIniciado: boolean = false;
  @Input() public linkVamosLa: string = '';
  @Input() public desafios: any;
  @Input() public desafioId: number;
  @Input() public idTipo: number = 1;
  @Input() public desafioAceito: boolean = false;
  @Input() public membro: any;
  @Input() public statusId: number;
  @Input() public caminhoImagem: string = '';
  @Input() public caminhoImagemMobile: string = '';
  @Input() public descricaoDeAceite: string = '';
  @Input() public ehMissaoDependente: boolean = false;
  @Input() public idGrupoMissaoDependente: string = '';
  @Input() public countMissoesDependente: number = 0;
  @Input() public indexGrupoMissaoDependente: number = 0;
  @Input() public listaMissoesDependente: any[] = [];
  @Input() public exibeCardsMultiplos: boolean = false;
  @Input() public removeMissaoDependenteCompletada: boolean = false;

  @Output() public onDesafioAceito: EventEmitter<any> = new EventEmitter();

  public exibirPopupDesafio: boolean = false;
  public exibirPopupDesafioExpirado: boolean = false;
  public exibirVamosLa: boolean = true;
  public exibirPopupDesafioCompletado: boolean = false;
  public exibirTimer: boolean = false;
  public exibirTimerDias: boolean = false;

  exibirPopupQuizz: boolean = false;

  public idQuizz: number = 0;
  public usuarioLogado: boolean = true;
  public idIndexMissao: number = 0;

  public loadingPopup: boolean = false;

  public missaoAtiva: number = 0;
  public missaoCompletada: number = 1;
  public missaoExpirada: number = 2;
  public diffInDays: number = 0;

  public ehQuizz: boolean = false;

  constructor(
    private fidelidadeService: FidelidadeService,
    private navigationService: NavigationService,
    private datePipe: DatePipe
  ) {}

  private readonly onDestroy: Subject<any> = new Subject<any>();

  ngOnInit(): void {
    if (this.idGrupoMissaoDependente != null)
      this.idIndexMissao = this.indexGrupoMissaoDependente;

    this.tratarDados();
  }

  tratarDados(): void {
    this.desafioCompleto = this.porcentagemDesafio === 100;
    this.desafioIniciado = this.porcentagemDesafio >= 0 && this.desafioAceito;
    this.porcentagemDesafio =
      this.porcentagemDesafio === undefined ? 0 : this.porcentagemDesafio;

    this.tratarExibicaoTimer();
    this.tratarExibicaoTimerDias();

    this.exibirVamosLa = !(
      this.linkVamosLa === '' &&
      !this.titulo.toLowerCase().includes('nosso primeiro date')
    );
  }

  onClickExibirPopupDesafio(): void {
    // if (this.desafioCompleto) return;
    this.exibirPopupDesafio = true;
  }

  definirIconeStatus(): string {
    let src = 'assets/images/icons/';

    if (this.desafioCompleto) src += 'filled_check';
    else if (this.desafioIniciado) src += 'circle_check';
    else src += 'circle_check';

    src += '_orange.png';

    return src;
  }

  onClick() {
    if (this.desafioCompleto) return;
    this.exibirPopupDesafio = true;
  }

  onClickExpirado() {
    if(this.ehMissaoDependente != undefined)
    {
      if (this.ehMissaoDependente) {
        this.exibirPopupDesafio = true;
        return;
      }
    }

    this.exibirPopupDesafioExpirado = true;
  }

  onClickCompletado() {
    if(this.ehMissaoDependente != undefined)
    {
      if (this.ehMissaoDependente) {
        this.exibirPopupDesafio = true;
        return;
      }
    }

    this.exibirPopupDesafioCompletado = true;
  }

  onClickCard() {
    if (this.statusId === this.missaoExpirada) {
      this.onClickExpirado();
    }
    if (this.statusId === this.missaoCompletada) {
      this.onClickCompletado();
    }
  }

  abrirDetalhes() {
    if (this.desafioCompleto || !this.desafioAceito) return;
    // this.exibirPopupDesafio = true;
    if (this.statusId !== this.missaoExpirada) this.desafioQuizz();
  }

  clickOkButton() {
    if (this.desafioAceito && this.linkVamosLa !== '') {
      this.navigationService.irParaLinkOuNavigate(this.linkVamosLa);
      return;
    }

    this.loadingPopup = true;

    this.fidelidadeService
      .aceitarDesafio(this.desafioId, this.membro.id)
      .subscribe({
        next: (res) => this.processarSucessoAceitarDesafio(res),
        error: (err) => this.processarFalhaAceitarDesafio(err),
      });
  }

  onClickTabMissao(desafio: any): void {
    this.preencherDados(desafio);

    this.tratarDados();
  }

  public desafioCompletado(desafio: any): boolean {
    return desafio.desafiosMembros[0]?.porcentagemFeita >= 100;
  }

  public disableBtnIniciair(): boolean {
    if (this.loadingPopup) return this.loadingPopup;

    if (!this.ehMissaoDependente) return this.loadingPopup;

    if (this.porcentagemDesafio >= 100) return this.loadingPopup;

    if (this.desafioAceito) return this.loadingPopup;

    if (!this.missaoAnteriorFoiCompletada()) return true;

    return this.loadingPopup;

    //return this.loadingPopup || (this.ehMissaoDependente && this.idIndexMissao != this.indexGrupoMissaoDependente);
  }

  private missaoAnteriorFoiCompletada(): boolean {
    const idMissaoAnterior = this.indexGrupoMissaoDependente - 1;
    if (idMissaoAnterior <= 0) return true;

    const missao = this.listaMissoesDependente.find(
      (x) => x.indexGrupoMissaoDependente == idMissaoAnterior
    );
    return missao?.desafiosMembros[0]?.porcentagemFeita >= 100;
  }

  public obterClassTabSelecionado(index: number): boolean {
    return index + 1 == this.indexGrupoMissaoDependente;
  }

  public obterNumeroCards(): any[] {
    if (!this.ehMissaoDependente || !this.exibeCardsMultiplos) return [];

    let count = 0;

    if (this.removeMissaoDependenteCompletada)
      count = this.listaMissoesDependente.filter(
        (x) =>
          x.desafiosMembros[0]?.porcentagemFeita < 100 ||
          x.desafiosMembros[0]?.porcentagemFeita == undefined
      ).length;
    else count = this.countMissoesDependente;

    return count >= 3 ? [1, 2] : count == 2 ? [1] : [];
  }

  public fecharPopup(): void {
    if (!this.ehMissaoDependente) {
      this.exibirPopupDesafio = false;
      return;
    }

    var desafio = this.listaMissoesDependente.find(
      (x) => x.indexGrupoMissaoDependente == this.idIndexMissao
    );
    this.preencherDados(desafio);
    this.tratarDados();
    this.exibirPopupDesafio = false;
  }

  public desafioEstaExpirado(): boolean {
    const dataAtual = new Date().toISOString();
    return dataAtual > this.fimDesafio?.toString();
  }

  private preencherDados(desafio: any): void {
    this.titulo = desafio.titulo;
    this.descricao = desafio.descricao;
    this.descricaoDeAceite = desafio.descricaoDeAceite;
    this.valorCacausRecompensa = desafio.pontos;
    this.valorPontosRecompensa = desafio.xp;
    this.caminhoImagem = desafio.caminhoImagem;
    this.caminhoImagemMobile = desafio.caminhoImagemMobile;
    this.desafioId = desafio.id;
    this.desafioAceito = desafio.desafioAceito;
    this.idTipo = desafio.idTipo;
    this.porcentagemDesafio = desafio.desafiosMembros[0]?.porcentagemFeita;
    this.indexGrupoMissaoDependente = desafio.indexGrupoMissaoDependente;
    this.inicioDesafio = desafio.dataInicio;
    this.fimDesafio = desafio.dataFim;
    // this.statusId = desafio.statusId;
  }

  private processarSucessoAceitarDesafio(res: any): void {
    this.onDesafioAceito.emit();
    this.loadingPopup = false;
    this.exibirPopupDesafio = false;

    if (this.linkVamosLa !== '') {
      this.navigationService.irParaLinkOuNavigate(this.linkVamosLa);
      return;
    }

    this.desafioQuizz();
  }

  private processarFalhaAceitarDesafio(err: any): void {
    alerts.exibirToast('error', err);
    console.error('Ocorreu um erro ao aceitar o desafio', err);
    this.loadingPopup = false;
  }

  private desafioQuizz(): void {
    this.fidelidadeService
      .obterDesafioPorId(this.desafioId)
      .subscribe((desafio) => {
        if (
          desafio.desafiosCondicoes[0].condicao.toString().includes('Quizz')
        ) {
          this.idQuizz = desafio.desafiosCondicoes[0].condicao
            .toString()
            .replace('Quizz.Id = ', '');
          this.usuarioLogado = true;

          this.fidelidadeService
            .obterQuizzPerguntasPorIdQuizz(this.idQuizz)
            .subscribe((quizz) => {
              this.exibirPopupDesafio = false;
              this.exibirPopupQuizz = true;
              // this.exibirPopupDesafio = true;
              // this.ehQuizz = true;
              // this.exibirPopupQuizz = false;
            });
        } else {
          this.exibirPopupDesafio = true;
        }
      });
  }

  public abrirQuiz() {
    this.exibirPopupDesafio = false;
    this.exibirPopupQuizz = true;
  }

  // public definirIconeDesafio(): string {
  //   let src: string = 'assets/images/icons/';

  //   switch (this.idTipo) {
  //     case 1:
  //       src += 'quebra_cabeca_peca';
  //       break;
  //     case 2:
  //       src += 'loja_fisica';
  //       break;
  //     case 3:
  //       src += 'dispositivos';
  //       break;
  //     case 4:
  //       src += 'cesto_compra';
  //       break;
  //     case 5:
  //       src += 'prancheta';
  //       break;
  //     case 6:
  //       src += 'coracao_unido';
  //       break;
  //     case 7:
  //       src += 'date_calendario';
  //       break;
  //   }

  //   src += '.png';

  //   return src;
  // }

  public definirImagemDesafio(): string {
    let src: string = '';

    switch (this.idTipo) {
      case 1:
        src = 'img__quebra_cabeca';
        break;
      case 2:
        src = 'img__loja_fisica';
        break;
      case 3:
        src = 'img__loja_online';
        break;
      case 4:
        src = 'img__cesta';
        break;
      case 5:
        src = 'img__quizz';
        break;
      case 6:
        src = 'img__coracao';
        break;
      case 7:
        src = 'img__data';
        break;
    }

    return src;
  }

  public definirImagemBackgroundCard(): string {
    if (this.statusId == this.missaoExpirada) {
      return this.definirImagemDesafio() + '_expirada';
    }

    return this.definirImagemDesafio();
  }

  public exibirDescritivoPontosECacaus(): boolean {
    return this.valorCacausRecompensa == 0 || this.valorPontosRecompensa == 0;
  }

  public exibirTextoDeAceite(): boolean {
    return (
      this.statusId == this.missaoAtiva &&
      this.descricaoDeAceite != null &&
      this.descricaoDeAceite != ''
    );
  }

  public tratarExibicaoTimer() {
    let dataAtual = this.datePipe.transform(new Date(), 'dd-MM-yyyy');
    let dataCard = this.datePipe.transform(this.fimDesafio, 'dd-MM-yyyy');

    if (
      (!this.desafioCompleto && this.desafioIniciado) ||
      !this.desafioAceito
    ) {
      if (dataAtual === dataCard) {
        this.exibirTimer = true;
      }
    }
  }

  public tratarExibicaoTimerDias() {
    let dataAtual = new Date();
    let dataCard = new Date(this.fimDesafio);

    let diffInMilliseconds = dataCard.getTime() - dataAtual.getTime();

    this.diffInDays = diffInMilliseconds / (1000 * 3600 * 24);

    if (
      (!this.desafioCompleto && this.desafioIniciado) ||
      !this.desafioAceito
    ) {
      if (this.diffInDays <= 30 && this.diffInDays >= 1) {
        this.exibirTimerDias = true;
      }
    }
  }

  ngOnDestroy() {
    this.onDestroy.next();
  }
}
